<template>
  <v-row>
    <v-col cols="12">
      <v-form :submit="submitUpdate">
        <v-row>
          <v-col cols="6">
            <v-text-field
                          label="Nome do caixa"
                          v-model="modelValue.name"
                          :rules="rules.required"></v-text-field>
          </v-col>
          <v-col cols="6" v-if="!modelValue.id">
            <v-text-field
                          label="Valor inicial do caixa"
                          v-model="modelValue.initial_amount"
                          type="number"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea
                        label="Descrição"
                        v-model="modelValue.description"
                        hide-details
                        counter></v-textarea>
          </v-col>

          <v-col cols="12">
            <v-autocomplete
                            label="Selecione o banco"
                            :items="brazilianBanksCodeNames"
                            v-model="modelValue.bank_code_name"
                            :disabled="requestingApi"
                            clearable>
              <template v-slot:no-data>
                <div class="px-4">Digite sua busca</div>
              </template></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <v-text-field
                          v-model="modelValue.bank_account_number"
                          label="Número da conta (com dígito)"
                          :disabled="requestingApi"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <v-text-field
                          v-model="modelValue.bank_account_agency"
                          label="Agência (com dígito)"
                          :disabled="requestingApi"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
                          v-model="modelValue.bank_pix"
                          label="Chave PIX"
                          prepend-inner-icon="mdi-key"
                          :disabled="requestingApi"></v-text-field>
          </v-col>
          <v-col cols="12" class="text-right">
            <v-btn color="success" type="submit"><v-icon class="mr-2">mdi-content-save</v-icon> Salvar</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>
<script>
import PaymentMethodList from './PaymentMethodList.vue';
import api from '@/services'
export default {
  components: { PaymentMethodList },
  props: {
    user: Object,
    modelValue: Object,
  },
  emits: ['update:modelValue', 'created', 'updated'],
  data() {
    return {
      requestingApi: null,
      brazilianBanks: [],
      rules: {
        required: [(v) => !!v || "Campo obrigatório"],
      },
    };
  },
  created() {
    var vm = this;
    if (!vm.modelValue?.id) {
      vm.value = vm.generateEmpty();
    }
    vm.fetchAllBanks()
  },
  mounted() { },
  methods: {
    fetchAllBanks() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.bank
          .list()
          .then((result) => {
            vm.brazilianBanks = result;
          })
          .catch((err) => {
            console.debug(err)
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    submitUpdate() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.cashier
          .updateOrCreate(vm.modelValue)
          .then((result) => {
            if (vm.modelValue?.id) {
              vm.$emit("updated", result);
            } else {
              vm.$emit("created", result);
            }
            vm.$notify({
              type: "success",
              text: "Dados alterados com sucesso",
            });
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    generateEmpty() {
      return {
        name: null,
        description: null,
        bank_code_name: null,
        bank_account_number: null,
        bank_account_agency: null,
        bank_pix: null,
        initial_amount: 0,
      };
    },
  },
  computed: {
    brazilianBanksCodeNames() {
      var vm = this;
      let _lstCodeName = [];
      vm.brazilianBanks.forEach((bank) => {
        if (bank.code) {
          let _codeName = `${bank.code < 10
            ? `000${bank.code}`
            : bank.code < 100
              ? `00${bank.code}`
              : bank.code < 1000
                ? `0${bank.code}`
                : bank.code
            } ${bank.fullName}`;
          _lstCodeName.push(_codeName);
        }
      });
      return _lstCodeName;
    },
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    group(newVal) {
      console.debug("GROUP changed", newVal);
      this.editGroup = newVal || this.generateEmpty();
    },
  },
};
</script>